import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-16">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">帮助中心</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问题</h2>
          <p className="mt-2 text-foreground-600 text-sm">关于黑料网站的常见疑问与解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <div className="p-5">
                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0 mt-0.5">
                    <span className="text-xs font-bold text-primary-600">Q</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-sm font-semibold text-foreground-900">{item.question}</h3>
                    <div className="mt-2 flex items-start gap-2">
                      <span className="text-[10px] font-bold text-foreground-400 mt-0.5">A</span>
                      <p className="text-sm text-foreground-700 leading-relaxed">{item.answer}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}